module.exports = __webpack_public_path__ + "26ad857a.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/articles/leasing/security.png
// module id = 3241
// module chunks = 21